import React from 'react';
import { useTranslation } from 'react-i18next';

import { CarsparencyLogoSvg } from '../../svg';
import { Button } from '../../ui';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const refresh_page = () => {
    location.href = '/';
  };

  return (
    <div className="tw-flex tw-flex-col tw-justify-center tw-h-screen tw-p-[16px] md:tw-items-center lg:tw-p-[130px]">
      <div className="tw-flex tw-flex-col tw-justify-center md:tw-items-center">
        <div
          className={
            'tw-flex tw-flex-col tw-justify-center tw-items-center tw-mb-[24px] md:tw-mb-[32px] lg:tw-flex-row-reverse tw-max-w-[1400px]'
          }
        >
          <CarsparencyLogoSvg
            className={'tw-h-[120px] tw-w-[244px] tw-absolute tw-top-[40px] lg:tw-hidden'}
          />
          <h1 className="tw-text-[110px] md:tw-text-[200px] tw-font-bold tw-leading-[110px] md:tw-leading-normal tw-text-center tw-text-gray0 lg:tw-flex-1 lg:-tw-mb-16">
            404
          </h1>
          <div className={'tw-flex tw-flex-col tw-items-center lg:tw-items-start lg:tw-flex-1'}>
            <CarsparencyLogoSvg className={'tw-h-[120px] tw-w-[244px] tw-hidden lg:tw-flex'} />
            <p className="tw-text-[18px] md:tw-text-[20px] lg:tw-text-[24px] tw-text-gray300">
              {t('page_not_found')}
            </p>
            <h4 className="tw-text-[24px] md:tw-text-[32px] lg:tw-text-[48px] tw-text-gray0 tw-mt-[16px] tw-text-center lg:tw-text-start tw-whitespace-pre-line md:tw-whitespace-normal">
              {t('this_page_doesnt_exist')}
            </h4>
          </div>
        </div>
        <Button size={'large'} color={'gray'} className={'lg:tw-self-start'} onClick={refresh_page}>
          {t('go_home')}
        </Button>
      </div>
    </div>
  );
};
